function redirectTo(destination) {
  window.location.assign(destination);
}

export { redirectTo };
